import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-images_style_4",
  "use": "icon-images_style_4-usage",
  "viewBox": "0 0 20 20.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.001\" id=\"icon-images_style_4\">\r\n  <path id=\"icon-images_style_4_联合_73\" data-name=\"联合 73\" class=\"cls-1\" d=\"M-5002-2012h-20v-20h20v20h0Zm-1.177-1.176v-17.647h-1.765v17.647Zm-2.94,0v-17.647h-6.471v17.647Zm-14.707,0h7.059v-17.647h-7.059Z\" transform=\"translate(5022 2032)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol